import React, { useState } from 'react';
import { useSnackbar } from 'notistack';
import X from '../../../../../../assets/icons/new_icon/x.svg';
import { editUserAccount } from '../../../../../../api/accounts';

interface Props {
  onClose: any;
  formData: any;
  setFormData: any;
  fetchData?: any;
  editContact?: any;
}

const EditContactModal = ({
  onClose,
  formData,
  setFormData,
  fetchData,
  editContact,
}: Props) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [tempFormData, setTempFormData] = useState({ ...formData });
  const [validating, setValidating] = useState(false);

  function handleAction() {
    setValidating(true);
    if (
      tempFormData.first_name &&
      tempFormData?.last_name &&
      tempFormData?.email &&
      tempFormData?.phone !== ''
    ) {
      setLoading(true);
      editUserAccount(tempFormData)
        .then((response) => {
          if (!response?.data?.is_error) {
            setLoading(false);
            fetchData(tempFormData.username);
            editContact(false);
            setFormData(tempFormData);
            setValidating(false);
          }
        })
        .catch((e) => {
          setLoading(false);
          editContact(false);
          setValidating(false);
        });
    }
  }

  const handleClose = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleSave = () => {
    // Update actual form data
    handleAction(); // Call the action to save/edit data
  };

  return (
    <div
      className='modal'
      id='terms_modal'
      style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5) ' }}
      tabIndex={-1}
      aria-labelledby='terms_modal_label'
      aria-hidden='true'
      onClick={handleClose}
    >
      {loading && (
        <div className='loader-container'>
          <div className='spinner'></div>
        </div>
      )}
      <div className='modal-dialog modal-md'>
        <div className='modal-content'>
          <div className='modal-header d-flex w-100 justify-content-between px-3 py-2'>
            <h3 className='newubbemodalheading  mb-0'>Contact Details</h3>
            <img
              src={X}
              onClick={() => onClose()}
              style={{ cursor: 'pointer' }}
            />
          </div>
          <div className='modal-body'>
            <div id='contact_inputs'>
              <div className='mb-3'>
                <label
                  htmlFor='first_name'
                  className='form-label globalInputLabel'
                >
                  First Name
                </label>
                <span className='text-danger'>*</span>
                <input
                  type='text'
                  className={`form-control  ubbe-input  ${
                    validating && tempFormData.first_name !== ''
                      ? 'is-valid'
                      : validating && tempFormData.first_name === ''
                      ? 'is-invalid'
                      : ''
                  } ${tempFormData.first_name ? 'highlighted-border' : ''}`}
                  id='first_name'
                  placeholder='First Name'
                  autoComplete='new-password'
                  value={tempFormData?.first_name}
                  onChange={(e) => {
                    setTempFormData({
                      ...tempFormData,
                      first_name: e.target.value,
                    });
                  }}
                />
                {validating && tempFormData?.first_name === '' && (
                  <div className='error_text'>
                    {'Please provide a valid code.'}
                  </div>
                )}
              </div>
              <div className='mb-3'>
                <label
                  htmlFor='last_name'
                  className='form-label globalInputLabel'
                >
                  Last Name
                </label>
                <span className='text-danger'>*</span>
                <input
                  type='text'
                  className={`form-control   ubbe-input  ${
                    validating && tempFormData.last_name !== ''
                      ? 'is-valid'
                      : validating && tempFormData.last_name === ''
                      ? 'is-invalid'
                      : ''
                  } ${tempFormData.last_name ? 'highlighted-border' : ''}`}
                  id='last_name'
                  placeholder='Last Name'
                  autoComplete='new-password'
                  value={tempFormData?.last_name}
                  onChange={(e) => {
                    setTempFormData({
                      ...tempFormData,
                      last_name: e.target.value,
                    });
                  }}
                />
                {validating && tempFormData?.last_name === '' && (
                  <div className='error_text'>
                    {'Please provide a valid code.'}
                  </div>
                )}
              </div>
              <div className='mb-3'>
                <label htmlFor='email' className='form-label globalInputLabel'>
                  Email
                </label>
                <span className='text-danger'>*</span>
                <input
                  type='email'
                  className={`form-control  ubbe-input  ${
                    validating && tempFormData.email !== ''
                      ? 'is-valid'
                      : validating && tempFormData.email === ''
                      ? 'is-invalid'
                      : ''
                  } ${tempFormData.email ? 'highlighted-border' : ''}`}
                  id='email'
                  placeholder='Email'
                  maxLength={100}
                  autoComplete='new-password'
                  value={tempFormData?.email}
                  onChange={(e) => {
                    setTempFormData({
                      ...tempFormData,
                      email: e.target.value,
                    });
                  }}
                />
                {validating && tempFormData?.email === '' && (
                  <div className='error_text'>
                    {'Please provide a valid code.'}
                  </div>
                )}
              </div>
              <div className='mb-3'>
                <label htmlFor='phone' className='form-label globalInputLabel'>
                  Phone
                </label>
                <span className='text-danger'>*</span>
                <input
                  type='text'
                  className={`form-control  ubbe-input ${
                    validating && tempFormData.phone !== ''
                      ? 'is-valid'
                      : validating && tempFormData.phone === ''
                      ? 'is-invalid'
                      : ''
                  } ${tempFormData.phone ? 'highlighted-border' : ''}`}
                  id='phone'
                  placeholder='Phone'
                  minLength={10}
                  maxLength={15}
                  autoComplete='new-password'
                  value={tempFormData?.phone}
                  onChange={(e) => {
                    setTempFormData({
                      ...tempFormData,
                      phone: e.target.value.replace(/[^0-9]/g, ''),
                    });
                  }}
                />
                {validating && tempFormData?.phone === '' && (
                  <div className='error_text'>
                    {'Please provide a valid code.'}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className='row mt-3 mb-2'>
            <div className='col-sm-12'>
              <p
                className='btn ubbe-blue-bg p-2 px-4 w-100 rounded-3 text-light d-flex m-auto justify-content-center align-items-center mb-2'
                style={{ maxWidth: 'max-content', height: '48px' }}
                onClick={handleSave} // Use handleSave function for submission
              >
                Update & Save
              </p>
              <u
                className='m-auto d-flex justify-content-center labelText'
                style={{ cursor: 'pointer' }}
                aria-label='Close'
                onClick={() => onClose()}
              >
                Cancel
              </u>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditContactModal;
